import {
  Button,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@geely/ui";
import { Plus } from 'lucide-react';
import { AdminLayout } from '@/app/components/AdminLayout';
import { PageHeader, PageLoading } from '@/app/components/shared';
import { TablePagination } from '@/app/components/shared/TablePagination';
import { WeeklyHoursTable } from './components/WeeklyHoursTable';
import { WeeklyHoursFormDialog } from './components/WeeklyHoursFormDialog';
import { SpecialDateHoursTable } from './components/SpecialDateHoursTable';
import { SpecialDateHoursFormDialog } from './components/SpecialDateHoursFormDialog';
import { useOperatingHoursPageData } from './hooks';

export function OperatingHoursPage() {
  const {
    // Store
    userStore,

    // Weekly Hours
    weeklyHours,
    isLoadingWeekly,
    isWeeklyDialogOpen,
    editingWeekly,
    handleOpenWeeklyDialog,
    handleCloseWeeklyDialog,
    handleSubmitWeekly,
    handleDeleteWeekly,

    // Special Date Hours
    specialDateHours,
    isLoadingSpecialDates,
    specialDatePaginationMeta,
    setSpecialDatePage,
    availableDatesForForm,
    isSpecialDateDialogOpen,
    editingSpecialDate,
    handleOpenSpecialDateDialog,
    handleCloseSpecialDateDialog,
    handleSubmitSpecialDate,
    handleDeleteSpecialDate,
  } = useOperatingHoursPageData();

  if (isLoadingWeekly) {
    return <PageLoading message="Carregando horários..." />;
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <PageHeader
          title="Gerenciar Horários"
          subtitle={
            userStore
              ? `Loja: ${userStore.name} | Atendimentos Simultâneos Padrão: ${userStore.parallelAppointments}`
              : undefined
          }
        />

        <Tabs defaultValue="weekly">
          <TabsList className="mb-3">
            <TabsTrigger value="weekly">Horários Semanais</TabsTrigger>
            <TabsTrigger value="special-dates">Datas Especiais</TabsTrigger>
          </TabsList>

          <TabsContent value="weekly" className="space-y-6">
            <PageHeader
              title="Horários Semanais"
              subtitle="Defina os horários de funcionamento para cada dia da semana"
              actions={
                <Button onClick={() => handleOpenWeeklyDialog()}>
                  <Plus className="size-4 mr-2" />
                  Novo Horário Semanal
                </Button>
              }
            />

            <WeeklyHoursTable
              hours={weeklyHours}
              userStore={userStore}
              onEdit={handleOpenWeeklyDialog}
              onDelete={handleDeleteWeekly}
            />

            <WeeklyHoursFormDialog
              isOpen={isWeeklyDialogOpen}
              editingHours={editingWeekly}
              userStore={userStore}
              onSubmit={handleSubmitWeekly}
              onClose={handleCloseWeeklyDialog}
            />
          </TabsContent>

          <TabsContent value="special-dates" className="space-y-6">
            <PageHeader
              title="Datas Especiais"
              subtitle="Cadastre exceções como feriados e expedientes especiais"
              actions={
                <Button onClick={() => handleOpenSpecialDateDialog()}>
                  <Plus className="size-4 mr-2" />
                  Nova Data Especial
                </Button>
              }
            />

            {isLoadingSpecialDates ? (
              <PageLoading message="Carregando datas especiais..." />
            ) : (
              <SpecialDateHoursTable
                hours={specialDateHours}
                userStore={userStore}
                onEdit={handleOpenSpecialDateDialog}
                onDelete={handleDeleteSpecialDate}
              />
            )}

            {specialDatePaginationMeta && (
              <TablePagination meta={specialDatePaginationMeta} onPageChange={setSpecialDatePage} />
            )}

            <SpecialDateHoursFormDialog
              isOpen={isSpecialDateDialogOpen}
              editingHours={editingSpecialDate}
              availableDates={availableDatesForForm}
              userStore={userStore}
              onSubmit={handleSubmitSpecialDate}
              onClose={handleCloseSpecialDateDialog}
            />
          </TabsContent>
        </Tabs>
      </div>
    </AdminLayout>
  );
}
